import { QueryClient } from '@tanstack/react-query'

import { ApiError } from '@/api/client'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status !== null && error.status < 500) {
          return false
        }
        return failureCount < 2
      },
      // Data other users/background jobs changed (a new application, a
      // teammate updating a job, a queued AI run finishing) never pushes an
      // update to a page unless something explicitly wires that up — most
      // pages don't. Refetching on window focus is the cheap, general-purpose
      // fix: switch back to the tab and whatever's on screen catches up
      // automatically instead of silently going stale until a manual reload.
      refetchOnWindowFocus: true,
    },
    mutations: {
      retry: false,
    },
  },
})
